import "firebase/auth";
import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { CustomerPublicProfile, DbTechnician, ProfileUpdateRequest, ProfileUpdateTechnicianRequest, RequestBecomeTechnicianData } from "../../models/user";
import { auth, functions } from "../../firebase/firebaseutil";
import { AddCustomerInput, AddTechnicianInput } from "../../types";

export enum RequestTypes {
  updateProfile = "updateProfile",
  getPublicCustomerProfile = "getPublicCustomerProfile",
  updateTechnicianProfileByAdmin = "updateTechnicianProfileByAdmin",
  updateCustomerProfileByAdmin = "updateCustomerProfileByAdmin",
  getPublicTechnicianProfile = "getPublicTechnicianProfile",
  updateTechnicianProfile = "updateTechnicianProfile",
  addNewTechnician = "addNewTechnician",
  addNewCustomer = "addNewCustomer",
  getUserByEmail = "getUserByEmail",
  getUserByPhone = "getUserByPhone",
  requestBecomeTechnician = "requestBecomeTechnician"
}

export default function useUpdateProfile() {
  const [updateStatus, setUpdateStatus] = useState<ProfileUpdateRequest>();
  const updateProfile = async (request: ProfileUpdateRequest): Promise<ProfileUpdateRequest> => {
    const userCallable = httpsCallable(functions, 'userCall');
    try {
      setUpdateStatus({});
      const result = await userCallable({ requestType: RequestTypes.updateProfile, input: request });
      const response = result.data as ProfileUpdateRequest;
      return response;
    } catch (err) {
      console.log("Error while updating profile", err);
      throw (err);
    }
  }

  const updateTechnicianProfile = async (request: ProfileUpdateTechnicianRequest): Promise<ProfileUpdateTechnicianRequest> => {
    const userCallable = httpsCallable(functions, 'userCall');
    try {
      setUpdateStatus({});
      const result = await userCallable({ requestType: RequestTypes.updateTechnicianProfile, input: request });
      const response = result.data as ProfileUpdateTechnicianRequest;
      return response;
    } catch (err) {
      console.log("Error while updating profile", err);
      throw (err);
    }
  }

  const updateTechnicianProfileByAdmin = async (request: ProfileUpdateTechnicianRequest): Promise<ProfileUpdateTechnicianRequest> => {
    const userCallable = httpsCallable(functions, 'userCall');
    try {
      setUpdateStatus({});
      const result = await userCallable({ requestType: RequestTypes.updateTechnicianProfileByAdmin, input: request });
      const response = result.data as ProfileUpdateTechnicianRequest;
      return response;
    } catch (err) {
      console.log("Error while updating profile", err);
      throw (err);
    }
  }
  const updateCustomerProfileByAdmin = async (request: ProfileUpdateRequest): Promise<ProfileUpdateRequest> => {
    const userCallable = httpsCallable(functions, 'userCall');
    try {
      setUpdateStatus({});
      const result = await userCallable({ requestType: RequestTypes.updateCustomerProfileByAdmin, input: request });
      const response = result.data as ProfileUpdateRequest;
      return response;
    } catch (err) {
      console.log("Error while updating profile", err);
      throw (err);
    }
  }

  const addNewTechnician = async (request: AddTechnicianInput) => {
    const userCallable = httpsCallable(functions, 'userCall');
    try {
      await userCallable({ requestType: RequestTypes.addNewTechnician, input: request });
      return true;
    } catch (err) {
      console.log("Error while creating technician", err);
      throw (err);
    }
  }

  const addNewCustomer = async (request: AddCustomerInput) => {
    const userCallable = httpsCallable(functions, 'userCall');
    try {
      await userCallable({ requestType: RequestTypes.addNewCustomer, input: request });
      return true;
    } catch (err) {
      console.log("Error while creating customer", err);
      throw (err);
    }
  }

  const getPublicCustomerProfile = async (request: string) => {
    try {
      if (auth?.currentUser?.uid) {
        const userCallable = httpsCallable(functions, 'userCall');
        const result = await userCallable({ requestType: RequestTypes.getPublicCustomerProfile, input: request });
        return result.data as CustomerPublicProfile;
      }
    } catch (e) {
      return false;
    }
  }
  const getPublicTechnicianProfile = async (request: string) => {
    try {
      if (auth?.currentUser?.uid) {
        const userCallable = httpsCallable(functions, 'userCall');
        const result = await userCallable({ requestType: RequestTypes.getPublicTechnicianProfile, input: request });
        return result.data as DbTechnician;
      }
    } catch (e) {
      return false;
    }
  }
  const requestBecomeTechnician = async (request: RequestBecomeTechnicianData) => {
    try {
      const userCallable = httpsCallable(functions, 'userCall');
      const result = await userCallable({ requestType: RequestTypes.requestBecomeTechnician, input: request });
      return result?.data as string;
    } catch (e) {
      console.log({e});
      
      return "Something went wrong, please try again after sometime.";
    }
  }


  return {
    updateStatus, updateProfile,
    updateTechnicianProfile, getPublicCustomerProfile,
    getPublicTechnicianProfile, updateTechnicianProfileByAdmin,
    updateCustomerProfileByAdmin, addNewTechnician, addNewCustomer, requestBecomeTechnician
  };
}
